<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="4">
          <el-cascader
            style="width:100%"
            clearable
            v-model="courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            collapse-tags
            placeholder="请输入所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-select v-model="searchForm.type" placeholder="请选择商品类型" clearable>
              <el-option value="">全部</el-option>
              <el-option value="题库">题库</el-option>
              <el-option value="直播">直播</el-option>
              <el-option value="录播">录播</el-option>
              <el-option value="面授">面授</el-option>
              <el-option value="套餐">套餐</el-option>
          </el-select>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.name" placeholder="请输入商品名称" auto-complete="off" clearable></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="2" style="text-align:right;float:right;margin-right:20px;">
          <el-button type="primary"  @click="addSelected" icon="el-icon-plus">批量添加</el-button>
        </el-col>
        <el-col :sm="24" :md="12" :lg="1" style="text-align:right;float:right;margin-right:30px;">
          <el-button type="primary" @click="addAll">全选</el-button>
        </el-col>
        <el-col :sm="24" :md="12" :lg="2" style="text-align:right;float:right;">
          <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
        </el-col>
        
        
      </el-row>
    </el-card>
    <el-card class="box-card" v-loading="loading">
      <!-- <el-row class="commodityCenter-header">
        <el-col :span="8">
          <div>
            代理商品
            <span>(已选择{{selectedNumber}})</span>
          </div>
        </el-col>
        <el-col :span="8" style="text-align:right;float:right">
          <el-button type="primary" @click="batchAddGoodsInfo()" :loading="batchAddGoodsInfoBlock">添加商品</el-button>
        </el-col>
      </el-row> -->
      <!-- <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="商品" width="300">
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <img
                    style="margin-right:10px;"
                    width="100%"
                    height="44px"
                    :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.recommend=='1'"
                >{{"[推荐]"}}</span>
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.hot=='1'"
                >{{"[热门]"}}</span>
                <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                <span style="display:block;margin-left:10px;">
                  <span style="color:red">￥{{row.row.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{row.row.originalPrice}}</span>
                </span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          width="100"
          label="类型"
          :render-header="renderSpecNameHeader"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目"></el-table-column>
        <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
          <template slot-scope="row">{{row.row.validDay}}天</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="销量/库存" align="center">
          <template slot-scope="row">
            <span>{{row.row.sellCount}}/{{row.row.stock}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="价格">
          <template slot-scope="row">
            <span style="color:red;font-weight:bold">{{row.row.price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="el-icon-view mainColor"
                style="font-size:20px"
                title="查看"
                @click="goGoodsInfo(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table> -->
      <div class="commodityCenter_box" v-if="page.rows.length>0">
        <div class="commodityCenter_box_item" v-for="(item,index) in page.rows" :key="index">
          <div class="commodityCenter_box_checkbox">
            <el-checkbox @change="change(item.id)" :value="checkeds[index].isChecked||false" :disabled="item.selected==1"></el-checkbox>
          </div>
          <img class="commodityCenter_box_img" height="120" width="200" :src="item.logo?item.logo:'../../../static/image/noImg.png'">
          <div>
            <div>
              <div class="commodityCenter_goods_detail">商品名称：{{item.name}}</div>
              <div class="commodityCenter_goods_detail">所属科目：{{item.subjectCourseName}}</div>
              <div class="commodityCenter_goods_detail">商品类型：{{item.type}}</div>
              <div class="commodityCenter_goods_detail">商品价格：
                <span style="">
                  <span style="color:red">￥{{item.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{item.originalPrice}}</span>
                </span>
              </div>
              <!-- <span style="color:rgb(77, 148, 255);margin-left:10px;">{{item.name}}</span>
                <span style="display:block;margin-left:10px;">
                  <span style="color:red">￥{{item.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{item.originalPrice}}</span>
                </span> -->
            </div>
            <div v-if="item.selected!==1" class="commodityCenter_box_button" @click="addGoodsInfo(item.id)">添加商品</div>
            <div v-else class="commodityCenter_box_button_false">添加商品</div>
          </div>
        </div>
      </div>
      <div v-else class="commodityCenter_box_false">暂无数据</div>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { Container } from 'element-ui';
import { mapGetters } from "vuex";
import SelectHeader from "./SelectHeader";
export default {
  data() {
    return {
      batchAddGoodsInfoBlock: false,
      tableData: [],
      addgoodsAgentPrice: {},
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      typeList: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 20,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      selectedNumber: 0,
      createTime: "",
      courseIds: [],
      searchForm: {
        courseIds: [],
        name: ""
      },
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      checkList: [],
      radio: "1",
      loading: false,
      fileAction: `${process.env.BASE_URL}/goodsInfo/upload`,
      fileList: [],
      updatePageId: "",
      goodsId: "",
      updatePageGoodsItem: "",
      selectGoods:[],
      checkeds:[]
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    // 批量添加，全部添加
    addSelected(){
      if(this.selectGoods.length>0){
        this.addGoodsInfo(this.selectGoods)
      }else{
        this.$message.warning('请先选择商品！');
      }
      
    },
    addAll(){
      this.checkeds.forEach(i=>{
        if(i.selected!=1){
          i.isChecked=!i.isChecked
        }
      })
      let arr = this.page.rows.filter(item=>item.selected!=1)
      let goodsIds=[];
      arr.forEach(Item=>{
        goodsIds.push(Item.id)
      })
      this.selectGoods=goodsIds

      console.log(goodsIds);
      // this.addGoodsInfo(goodsIds)
    },
    change(e){
      let hasGood = -1
      this.selectGoods.forEach(i=>{
        if(e==i) hasGood = 1
      })
      console.log(hasGood);
      if(hasGood==1){
        this.selectGoods.forEach((val,index)=>{
          if(e==val){
            this.selectGoods.splice(index,1)
          }
        })
      }else{
        this.selectGoods.push(e)
      }

      this.checkeds.forEach(item=>{
        if(e==item.id){
          item.isChecked=!item.isChecked
        }
      })
      console.log(this.selectGoods);
      console.log(this.checkeds);
    },
    radioChange() {
      if (this.radio != null) {
        this.checkList = [];
        this.searchForm.typeList = [];
      }
    },
    checkboxChange() {
      if (this.checkList.length > 0) {
        this.radio = null;
        this.searchForm.typeList = this.checkList;
      } else {
        this.radio = "1";
      }
    },
    goGoodsInfo(row) {
      this.$router.push({
        path: "/goGoodsInfo",
        query: {
          id: row.id
        }
      });
    },
    goodsItem(row) {
      this.updatePageGoodsItem = row.id;
      this.$router.push({
        path: "/goodsItem",
        query: {
          updatePageGoodsItem: this.updatePageGoodsItem
        }
      });
    },
    subjectSearchChange() {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach(item => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  delete items.children;
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    checkSelectable(row) {
      return row.selected == -1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(e => {
        this.multipleSelection.push(e.id);
      });
      this.selectedNumber = this.multipleSelection.length;
      // this.multipleSelection = val;
    },
    //获取数据
    getGoodsInfo() {
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePage
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGoodsInfo(id) {
      if(this.batchAddGoodsInfoBlock){
        return false;
      }
      this.batchAddGoodsInfoBlock = true;
      let ids;
      if(Array.isArray(id)){
        //是数组
        ids=id
      }else{
        // 不是数组
        ids=[id]
      }
      this.api.goodsInfo
        .batchAddGoodsInfo({ goodsIdList: ids })
        .then(result => {
          if (result.success) {
            this.batchAddGoodsInfoBlock = false;
            this.$message.success(result.message);
            this.selectGoods=[]
            this.pageList();
          } else {
            this.batchAddGoodsInfoBlock = false;
            this.$message.error(result.message);
          }
        });
    },
    batchAddGoodsInfo() {
      if(this.selectedNumber==0){
        this.$message.warning("请选择需要添加的商品！");
        return false;
      }
      if(this.batchAddGoodsInfoBlock){
        return false;
      }
      this.batchAddGoodsInfoBlock = true;
      this.api.goodsInfo
        .batchAddGoodsInfo({ goodsIdList: this.multipleSelection })
        .then(result => {
          if (result.success) {
            this.page.pageNumber = 1;
            this.batchAddGoodsInfoBlock = false;
            this.$message.success(result.message);
            this.pageList();
          } else {
            this.batchAddGoodsInfoBlock = false;
            this.$message.error(result.message);
          }
        });
    },
    pageList() {
      console.log("111111")
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfoCenter
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.rows.forEach(item=>{
            this.checkeds.push({
              id:item.id,
              isChecked:false,
              selected:item.selected
            })
          })
          // for (let i in this.page.rows) {
          //   this.page.rows[i].tags = this.page.rows[i].tags.split(" ");
          // }
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      console.log(column);
      //列号
      console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px"
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label
            }
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "order",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName"
              }
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            }
          })
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.page.pageNumber = 1;
      this.searchForm.type = val;
      this.pageList();
      //写点啥吧
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    }
  },
  watch: {},
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.commodityCenter-header {
}
.commodityCenter_box{
  display: flex;
  flex-wrap: wrap;
}
.commodityCenter_box_false{
  text-align: center;
  padding: 20px;
  color: #909399;
}
.commodityCenter_box_item{
  position: relative;
  margin: 10px 10px 50px 10px;
}
.commodityCenter_box_checkbox{
  position: absolute;
  top: 10px;
  left: 10px;
}
.commodityCenter_box_img{
  border-radius: 10px;
}
.commodityCenter_goods_detail{
  color: #999;
  line-height: 30px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.commodityCenter_box_button{
  text-align: center;
  background-color: #FF6A00;
  color: #fff;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
}
.commodityCenter_box_button_false{
  text-align: center;
  background-color: #c9c9c9;
  color: #999;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
}
.commodityCenter_box_button:hover{
  opacity: 0.7;
  cursor: pointer;
}
.el-radio {
  line-height: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/agencyGoods/commodityCenter.vue